<div class="flex flex-col">
  <input
    #fileInput
    type="file"
    accept="image/*"
    capture="environment"
    hidden
    (change)="onInputChange($event)"
  />
  <ui-button
    class="flex-1"
    type="secondary"
    responsive="false"
    size="sm"
    button-text="Tomar foto"
    (clicked)="openCamera()"
  ></ui-button>
</div>
